"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIcon = exports.CSS = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const render_service_1 = require("../../services/render.service");
const userDisplayName_1 = require("../../util/userDisplayName");
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-UserIcon',
    unknown: 'c-UserIcon--Unknown'
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        width: theme_1.DefaultTheme.space(8),
        height: theme_1.DefaultTheme.space(8),
        'min-width': theme_1.DefaultTheme.space(8),
        'max-height': theme_1.DefaultTheme.space(8),
        'border-radius': '50%',
        color: theme_1.DefaultTheme.font.color.white,
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center'
    },
    [exports.CSS.unknown]: {
        'background-color': theme_1.DefaultTheme.font.color.divider
    }
});
exports.UserIcon = {
    view(user) {
        if (user == null) {
            return (0, render_service_1.m)('div', { className: `${exports.CSS.container} ${exports.CSS.unknown}` });
        }
        const color = core_shared_1.ColorHash.hash(user.objectId);
        return (0, render_service_1.m)('div', {
            className: exports.CSS.container,
            title: (0, userDisplayName_1.userDisplayName)(user),
            style: {
                'background-color': color
            }
        }, (0, userDisplayName_1.userDisplayInitials)(user));
    }
};
//# sourceMappingURL=user.icon.js.map